import sunglassesSrc from './assets/images/sunglasses.png';
import glassesSrc from './assets/images/glasses.png';

/**
 * Minimal local catalog (no backend).
 * You can extend with more PNGs + metadata later.
 */
export const GLASSES_CATALOG = [
  {
    id: 'sunglasses_black',
    name: 'Sunglasses',
    src: sunglassesSrc,
    category: 'sunglasses',
    gender: 'unisex',
    // optional hints for "similar" filtering
    recommendedForFaceShapes: ['oval', 'square'],
    // Example cart URL (replace with your shop URL)
    addToCartUrl: 'https://mojenaocale.ba/cart/add?sku=sunglasses_black',
  },
  {
    id: 'glasses_classic',
    name: 'Classic Glasses',
    src: glassesSrc,
    category: 'dioptric',
    gender: 'unisex',
    recommendedForFaceShapes: ['round', 'heart', 'oval'],
    // Example cart URL (replace with your shop URL)
    addToCartUrl: 'https://mojenaocale.ba/cart/add?sku=glasses_classic',
  },
];

export function getGlassesById(id) {
  return GLASSES_CATALOG.find((g) => g.id === id) ?? GLASSES_CATALOG[0];
}

/**
 * "Similar glasses" for the right sidebar.
 * If a face shape is known+locked, prefer those recommended for that shape.
 */
export function getSimilarGlasses({ selectedId, faceShape, faceShapeLocked }) {
  const others = GLASSES_CATALOG.filter((g) => g.id !== selectedId);
  if (!faceShapeLocked || !faceShape) return others;

  const preferred = others.filter((g) => (g.recommendedForFaceShapes || []).includes(faceShape));
  return preferred.length ? preferred : others;
}





